import React from 'react';
import './Landing.css';

export default function Privacy() {
  return (
    <div className="landing">
      <section className="hero" style={{ paddingBottom: '2rem' }}>
        <h1 className="landing-title" style={{ fontSize: '2.5rem' }}>Privacy Policy</h1>
      </section>

      <section style={{ maxWidth: '600px', margin: '0 auto', lineHeight: '1.8', color: '#6D6056' }}>
        <p><strong style={{ color: '#5D4037' }}>Effective Date:</strong> February 27, 2026</p>

        <p>String App ("String," "we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information.</p>

        <h2 style={{ color: '#5D4037', fontSize: '1.15rem', marginTop: '2rem' }}>Information We Collect</h2>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li><strong>Name</strong> — to personalize your experience</li>
          <li><strong>Email address</strong> — to send event reminders</li>
          <li><strong>Phone number</strong> — to send SMS reminders (if opted in)</li>
          <li><strong>Contact information you provide</strong> — names, birthdays, and anniversaries of people you want to remember</li>
          <li><strong>Gift ideas</strong> — notes you save for your contacts</li>
        </ul>

        <h2 style={{ color: '#5D4037', fontSize: '1.15rem', marginTop: '2rem' }}>How We Use Your Information</h2>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li>To send you birthday and anniversary reminders via SMS and/or email</li>
          <li>To process your requests sent via SMS</li>
          <li>To improve and maintain the service</li>
        </ul>

        <h2 style={{ color: '#5D4037', fontSize: '1.15rem', marginTop: '2rem' }}>Information Sharing</h2>
        <p>We do <strong>not</strong> sell, rent, or share your personal information, including your phone number, with any third parties for marketing purposes. Your data is used solely to provide the String reminder service.</p>
        <p>We may share information only with service providers necessary to operate String (e.g., Twilio for SMS delivery, Resend for email delivery). These providers are bound by their own privacy policies and are used only for delivering your messages.</p>

        <h2 style={{ color: '#5D4037', fontSize: '1.15rem', marginTop: '2rem' }}>Data Storage & Security</h2>
        <p>Your data is stored securely and we take reasonable measures to protect it from unauthorized access. We retain your data only as long as your account is active or as needed to provide the service.</p>

        <h2 style={{ color: '#5D4037', fontSize: '1.15rem', marginTop: '2rem' }}>Your Rights</h2>
        <p>You may request to delete your account and all associated data at any time by contacting us at <a href="mailto:reminders@stringapp.co" style={{ color: '#6B7F5E' }}>reminders@stringapp.co</a>.</p>

        <h2 style={{ color: '#5D4037', fontSize: '1.15rem', marginTop: '2rem' }}>Changes</h2>
        <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date.</p>

        <p style={{ marginTop: '2rem' }}>
          <strong style={{ color: '#5D4037' }}>Contact:</strong>{' '}
          <a href="mailto:reminders@stringapp.co" style={{ color: '#6B7F5E' }}>reminders@stringapp.co</a>
        </p>
      </section>

      <footer className="landing-footer" style={{ marginTop: '3rem' }}>
        <p>Like tying a string around your finger.</p>
      </footer>
    </div>
  );
}
